/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionsAnalyticsDataSchema = z.object({
	formId: z.string(),
	period: z.array(z.string()),
	funnel: z.array(
		z.object({
			step: z.string(),
			label: z.string(),
			sessions: z.number(),
			conversionRate: z.number().nullable(),
			rateFromBaseline: z.number().nullable(),
		}),
	),
	timeToAnswer: z.array(
		z.object({
			questionId: z.string(),
			position: z.number(),
			label: z.string(),
			type: z.string(),
			avgTimeToAnswerMs: z.number().nullable(),
			answerCount: z.number(),
		}),
	),
})

export type AdditionalQuestionsAnalyticsDataSchema = z.infer<typeof additionalQuestionsAnalyticsDataSchema>
